import React from 'react';

import _ from 'lodash';
import ArticleTags from './ArticleTags.jsx';
import Html from '~/commons/components/Html.jsx';
import AnimatedContent from './AnimatedContent.jsx';

const Article = ({
  article, hideTags, children, hideTitle = false,
}) => (
  <div className="readable">
    {!hideTitle && <h1 className="h2 mt-3 mb-4">{article.title}</h1>}
    {!hideTags && <ArticleTags className="mb-2" tags={article.tags} />}
    {children}
    {_.isEmpty(article.contents) && article.content && (
      <Html>{article.content}</Html>
    )}
    {!_.isEmpty(article.contents) && _.map(article.contents, (content, idx) => (
      <AnimatedContent
        key={idx}
        img={content.img}
        content={content.content}
        animation={content.animation}
      />
    ))}
  </div>
);

export default Article;
